import TimeUtils from '../helper/TimeUtils';
import StringUtils from '../helper/StringUtils';
import DataObj from './DataObj';

// 每一個檢測出來的錯誤類型與訊息
class StyleCheckObj {
  constructor(dataObj) {
    (this.rowIndex = dataObj.rowIndex),
      (this.typeName = dataObj.typeName),
      (this.errorMessage = dataObj.errorMessage);
  }
}
const INIT_DATA_JSON = {
  'Frame split error': [],
  'Character limit': [],
  'Duration error': [],
  'Max line count error': [],
  'Maximum & Minimum length': [],
  'Maximun Duration': [],
  'Minimum Duration': [],
  'Character Per Second': [],
  'Timecode Error': [],
};

class Style {
  constructor(dataObj) {
    //todo:此處先預設2 之後直接採用本地儲存
    //this.fFrameSplit = dataObj.fFrameSplit,
    //this.fFrameSplit = SubTitleUtils.get_fFrameSplit_from_local(),
    (this.fFrameSplit = dataObj.fFrameSplit),
      (this.fIsUseResolutionXY = dataObj.fIsUseResolutionXY),
      (this.fResolutionX = dataObj.fResolutionX),
      (this.fResolutionY = dataObj.fResolutionY),
      (this.fCharacterByteType = dataObj.fCharacterByteType),
      (this.fMinLengthPerLine = dataObj.fMinLengthPerLine),
      (this.fMaxLengthPerLine = dataObj.fMaxLengthPerLine),
      (this.fIsCharacterPerSecondType = dataObj.fIsCharacterPerSecondType),
      (this.fMinLengthPerSecond = dataObj.fMinLengthPerSecond),
      (this.fMaxLengthPerSecond = dataObj.fMaxLengthPerSecond),
      (this.fIsExcludeSpaces = dataObj.fIsExcludeSpaces),
      (this.fIsExcludePunctuations = dataObj.fIsExcludePunctuations),
      (this.fMaxDurationSecond = dataObj.fMaxDurationSecond),
      (this.fMaxDurationFram = dataObj.fMaxDurationFram),
      (this.fMinDurationSecond = dataObj.fMinDurationSecond),
      (this.fMinDurationFram = dataObj.fMinDurationFram),
      (this.fMaxCountOfLines = dataObj.fMaxCountOfLines),
      (this.fSaveAreaXLeft = dataObj.fSaveAreaXLeft),
      (this.fSaveAreaXRight = dataObj.fSaveAreaXRight),
      (this.fSaveAreaYTop = dataObj.fSaveAreaYTop),
      (this.fSaveAreaYBottom = dataObj.fSaveAreaYBottom),
      (this.fFontId = dataObj.fFontId),
      (this.fFontSize = dataObj.fFontSize),
      (this.fLineSpacing = dataObj.fLineSpacing),
      (this.fCharaterSpacing = dataObj.fCharaterSpacing),
      (this.fIsAllowPositioning = dataObj.fIsAllowPositioning),
      (this.fAllowPositioningType = dataObj.fAllowPositioningType),
      (this.fCenterJustificationType = dataObj.fCenterJustificationType),
      (this.fIsRemoveContinuousWhitespace =
        dataObj.fIsRemoveContinuousWhitespace),
      (this.fQC_MissingTimecodeError = dataObj.fQC_MissingTimecodeError),
      (this.fQC_TimecodeOverlapError = dataObj.fQC_TimecodeOverlapError),
      (this.fQC_DurationError_min = dataObj.fQC_DurationError_min),
      (this.fQC_DurationError_max = dataObj.fQC_DurationError_max),
      (this.fQC_EmptySubError = dataObj.fQC_EmptySubError),
      (this.fQC_ChartacterLimtError = dataObj.fQC_ChartacterLimtError),
      (this.fQC_ReadSpeedError = dataObj.fQC_ReadSpeedError),
      (this.fQC_MaxLineError = dataObj.fQC_MaxLineError),
      (this.fQC_PositionCheckError = dataObj.fQC_PositionCheckError),
      (this.fQC_NetflixWhitelistCharactersCheckError =
        dataObj.fQC_NetflixWhitelistCharactersCheckError),
      (this.fQC_Half_white_ChartaterError =
        dataObj.fQC_Half_white_ChartaterError);

    //介面顯示 安插鎖有StyleCheckObj
    this.TotalErrorData = INIT_DATA_JSON; //有錯誤 就安插進去 {"type":false,"rowIndex":0}

    //臨時使用的訊息欄位
    this.RowErrorMessage = {
      rowIndex: 0,
      type: true,
      message: [],
    };
  }

  runTargetCheck(DataObjArray, callback) {
    //console.log('=========== runTargetCheck ========== ')

    //let newFrameSpliteErrorArray = [];

    // DataObjArray.map((data,index)=>{
    //
    //
    // })

    //檢察 findFrameSplitValue
    //rowIndex
    //type　true false
    //classF : 類別名稱[]
    //1.FrameSplitError
    //

    let newTargetErrorArray = [];
    this.TotalErrorData = {
      'Frame split error': [],
      'Character limit': [],
      'Duration error': [],
      'Max line count error': [],
      'Maximum & Minimum length': [],
      'Maximun & Minimum Duration': [],
      'Character Per Second': [],
      'Timecode Error': [],
    };
    DataObjArray.map((ROWoBJ, index) => {
      // type(pin):"Out"
      // rowIndex(pin):0
      // nextIndex(pin):1
      // outTime(pin):"00:00:00.12"

      //刷新臨時使用的訊息欄位
      this.RowErrorMessage = {
        rowIndex: index,
        type: true,
        message: [],
      };

      /***
       * FrameSplitError 檢測
       */
      this.getFrameSplitErrorArray(index, DataObjArray, ROWoBJ);

      /***
       * 每一行的最長 字元 或是 bytes 數 fIsCharacterPerSecondType
       */
      this.getLengthPerLineErrorArray(index, ROWoBJ);

      /***
       * 產生時間總長 Duration error
       */
      this.getDurationError(index, ROWoBJ);

      /***
       * 行數錯誤 fMaxCountOfLines
       */
      this.getCountOfLinesError(index, ROWoBJ);

      /***
       * CPS錯誤 fIsCharacterPerSecondType : fMinLengthPerSecond fMaxLengthPerSecond
       */
      this.getCharacterPerSecondError(index, ROWoBJ);

      /***
       * Timecode 格式錯誤
       */
      this.getTimecodeError(index, ROWoBJ, DataObjArray);

      //累計每一個Row的長度
      newTargetErrorArray.push(this.RowErrorMessage);
    });

    callback({
      frameSpliteErrorArray: newTargetErrorArray,
      TotalErrorData: this.TotalErrorData,
    });
    // console.log({
    //     frameSpliteErrorArray:newTargetErrorArray,
    //     TotalErrorData:this.TotalErrorData
    // })
    //console.log('=========== end of runTargetCheck ========== ')

    // return {
    //     frameSpliteErrorArray:newTargetErrorArray,
    //     TotalErrorData:this.TotalErrorData
    // }
  }

  /**
   * 每一行的最長字元或是bytes數
   * */
  getLengthPerLineErrorArray(index, ROWoBJ) {
    let isLowerMin = false; //低於門檻
    let isOverMax = false; //超過上限

    //判斷 fCharacterByteType 1:Character 0:Byte
    // "fMinLengthPerLine": 0, 低於0
    // "fMaxLengthPerLine": 42, 高於限制

    let SubtitleCaption = ROWoBJ['SubtitleCaption'];

    let LengthTitle = ROWoBJ['LengthTitle'];

    //利用\n來分開行數

    let stringLength = 0;
    if (SubtitleCaption.includes('\n') === true) {
      //多行的

      //多行處理
      const stringArray = SubtitleCaption.split('\n');
      const LengthArray = LengthTitle.split('\n');
      //console.log('Number of breaks: ' + stringArray);
      let index = 0;
      stringArray.map((targetString) => {
        // 單行長度
        let RowStringLength = StringUtils.GetStringByCharacterorByte(
          this.fCharacterByteType,
          targetString
        );

        //如果是Char
        if (this.fCharacterByteType === 1) {
          RowStringLength = parseFloat(LengthArray[index]);
        } else {
          //如果是byte
          RowStringLength = StringUtils.GetStringByCharacterorByte(
            this.fCharacterByteType,
            targetString
          );
        }

        if (RowStringLength < this.fMinLengthPerLine) {
          isLowerMin = true;
        }

        if (RowStringLength > this.fMaxLengthPerLine) {
          isOverMax = true;
        }

        index += 1;
      });
    } else {
      // 單行處理
      stringLength = StringUtils.GetStringByCharacterorByte(
        this.fCharacterByteType,
        SubtitleCaption
      );

      if (this.fCharacterByteType === 1) {
        //如果是Char
        stringLength = parseFloat(LengthTitle);
      } else {
        //如果是byte
        stringLength = StringUtils.GetStringByCharacterorByte(
          this.fCharacterByteType,
          SubtitleCaption
        );
      }

      if (stringLength < this.fMinLengthPerLine) {
        isLowerMin = true;
      }

      if (stringLength > this.fMaxLengthPerLine) {
        isOverMax = true;
      }
    }

    if (isLowerMin === true) {
      this.RowErrorMessage['type'] = false; //錯誤類型
      this.RowErrorMessage['message'].push(
        '每一行的最長字元或是bytes數 低於門檻'
      );

      //低於門檻
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Character limit',
        errorMessage: `It's over the minimum limit per line.${
          this.fCharacterByteType === parseFloat(0)
            ? `(Byte:${this.fMinLengthPerLine})`
            : ''
        }`,
      });
      this.TotalErrorData['Character limit'].push(newStyleCheckObj);
    }

    if (isOverMax === true) {
      this.RowErrorMessage['type'] = false; //錯誤類型
      this.RowErrorMessage['message'].push(
        '每一行的最長字元或是bytes數 超過限制'
      );

      //超過限制
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Character limit',
        errorMessage: ` It's over the maximum limit per line. ${
          this.fCharacterByteType === parseFloat(0)
            ? `(Byte:${this.fMaxLengthPerLine})`
            : ''
        }`,
      });
      this.TotalErrorData['Character limit'].push(newStyleCheckObj);
    }
  }

  /**
   * 檢查影格間距
   * */
  getFrameSplitErrorArray(index, DataObjArray, ROWoBJ) {
    const currentInString = ROWoBJ.In;
    const currentOutString = ROWoBJ.Out;

    const currentInFrame =
      TimeUtils.timeString_convertTo_frame(currentInString);
    const currentFrame = TimeUtils.timeString_convertTo_frame(currentOutString);

    const durationFrame = parseFloat(currentFrame) - parseFloat(currentInFrame);

    //時間小於0
    if (durationFrame < 0) {
      this.RowErrorMessage['type'] = false; //錯誤類型
      this.RowErrorMessage['message'].push('影格間距小於0');

      //影格間距小於0
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Frame split error',
        errorMessage: 'Frame duration less than 0',
      });
      this.TotalErrorData['Frame split error'].push(newStyleCheckObj);
    }

    // 只有最後一個沒有間距
    if (index !== DataObjArray.length - 1) {
      const nextROWoBJ = DataObjArray[index + 1];
      const nextInString = nextROWoBJ.In;

      const nextFrame = TimeUtils.timeString_convertTo_frame(nextInString);
      //
      // const countFrameNumber = Math.ceil(nextFrame - currentFrame);

      let frameCount = nextFrame - currentFrame;

      if (nextFrame === 0) {
        //下一格都沒有時間 不是錯
      } else if (nextFrame === 0 && currentFrame === 0) {
        //下一格都沒有時間 不是錯
      } else if (frameCount < this.fFrameSplit) {
        //時間的間格小於

        const newStyleCheckObj = new StyleCheckObj({
          rowIndex: index,
          typeName: 'Frame split error',
          errorMessage: `Frame gap less than ${this.fFrameSplit} frame(s).`,
        });
        this.TotalErrorData['Frame split error'].push(newStyleCheckObj);

        //console.log(`countFrameNumber 錯 ${index} ${frameCount}  ${findFrameSplitValue+1} `);
      }
    }
  }

  /**
   * 檢察時間的長度
   * */
  getDurationError(index, ROWoBJ) {
    const MaxDuration = `00:00:${this.fMaxDurationSecond}.${this.fMaxDurationFram}`;
    const MinDuration = `00:00:${this.fMinDurationSecond}.${this.fMinDurationFram}`;

    const currentInString = ROWoBJ.In;
    const currentOutString = ROWoBJ.Out;

    if (currentInString !== '' && currentOutString !== '') {
      const MaxDurationFrame =
        TimeUtils.timeString_convertTo_frame(MaxDuration);
      const MinDurationFrame =
        TimeUtils.timeString_convertTo_frame(MinDuration);

      const currentInFrame =
        TimeUtils.timeString_convertTo_frame(currentInString);
      const currentFrame =
        TimeUtils.timeString_convertTo_frame(currentOutString);
      const durationFrame =
        parseFloat(currentFrame) - parseFloat(currentInFrame);

      //大於時間
      if (durationFrame > MaxDurationFrame) {
        this.RowErrorMessage['type'] = false; //錯誤類型
        this.RowErrorMessage['message'].push('時間的長度大於時間');

        const newStyleCheckObj = new StyleCheckObj({
          rowIndex: index,
          typeName: 'Duration error',
          errorMessage: `Duration frame more than ${MaxDurationFrame} (frame:${parseInt(
            durationFrame
          )})`,
        });
        this.TotalErrorData['Duration error'].push(newStyleCheckObj);
      }

      //小於時間
      if (durationFrame < MinDurationFrame) {
        this.RowErrorMessage['type'] = false; //錯誤類型
        this.RowErrorMessage['message'].push('時間的長度小於時間');

        const newStyleCheckObj = new StyleCheckObj({
          rowIndex: index,
          typeName: 'Duration error',
          errorMessage: `Duration frame less than ${MinDurationFrame} (frame:${parseInt(
            durationFrame
          )})`,
        });
        this.TotalErrorData['Duration error'].push(newStyleCheckObj);
      }

      // console.log(`durationFrame ${MaxDurationFrame} ${MinDurationFrame} ${currentInString} ${currentOutString} ${durationFrame}`)
    }
  }

  /**
   * 檢察行數數量
   * */
  getCountOfLinesError(index, ROWoBJ) {
    //fMaxCountOfLines

    let SubtitleCaption = ROWoBJ['SubtitleCaption'];

    //利用\n來分開行數

    if (SubtitleCaption.includes('\n') === true) {
      //多行處理
      const stringArray = SubtitleCaption.split('\n');

      if (parseFloat(stringArray.length) > parseFloat(this.fMaxCountOfLines)) {
        this.RowErrorMessage['type'] = false; //錯誤類型
        this.RowErrorMessage['message'].push(
          '行數數量(' + stringArray.length + ')大於限制' + this.fMaxCountOfLines
        );

        //高於門檻
        const newStyleCheckObj = new StyleCheckObj({
          rowIndex: index,
          typeName: 'Max line count error',
          errorMessage: `exceeds the max line count limit (Max : ${this.fMaxCountOfLines} lines)`,
        });
        this.TotalErrorData['Max line count error'].push(newStyleCheckObj);
      }
    }
  }

  /**
   * CPS錯誤 fIsCharacterPerSecondType : fMinLengthPerSecond fMaxLengthPerSecond
   */
  getCharacterPerSecondError(index, ROWoBJ) {
    //fMaxCountOfLines

    let CPS = ROWoBJ['CPS'];

    if (parseFloat(CPS) > parseFloat(this.fMaxLengthPerSecond)) {
      this.RowErrorMessage['type'] = false; //錯誤類型
      this.RowErrorMessage['message'].push(
        'CPS錯誤(' + CPS + ')大於限制' + this.fMaxLengthPerSecond
      );

      //高於門檻
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Character per second error',
        errorMessage: `exceeds by ${parseFloat(
          parseFloat(CPS) - parseFloat(this.fMaxLengthPerSecond).toFixed(1)
        )}`,
      });
      this.TotalErrorData['Character Per Second'].push(newStyleCheckObj);
    }

    if (parseFloat(CPS) < parseFloat(this.fMinLengthPerSecond)) {
      this.RowErrorMessage['type'] = false; //錯誤類型
      this.RowErrorMessage['message'].push(
        'CPS錯誤(' + CPS + ')小於限制' + this.fMinLengthPerSecond
      );

      //低於門檻
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Character per second error',
        errorMessage: `lowrer then CPS limit (Min : ${this.fMinLengthPerSecond})`,
      });
      this.TotalErrorData['Character Per Second'].push(newStyleCheckObj);
    }
  }

  /**
   * 檢查格式
   * @param {*} index
   * @param {*} ROWoBJ
   */
  getTimecodeError(index, ROWoBJ, DataObjArray) {
    if (
      ROWoBJ.In === '' ||
      ROWoBJ.Out === '' ||
      ROWoBJ.SubtitleCaption === ''
    ) {
      return;
    }

    const { Duration } = ROWoBJ;
    // CPS:
    // 16.8
    // Duration:
    // 3.21
    // DurationTitle:
    // '3.21\n(16.8)'
    // end:
    // 7.667
    // In:
    // '00:00:04.11'
    // InTimecode:
    // '00:00:04,458'
    // isIgnoreShotchange:
    // false
    // isInShotChangeActive:
    // false
    // isOutShotChangeActive:
    // false
    // Length:
    // '23\n31'
    // LengthTitle:
    // '23\n31'
    // Memo:
    // ''
    // Out:
    // '00:00:07.16'
    // OutTimecode:
    // '00:00:07,666'
    // Position:
    // ''
    // ShotChange:
    // ''
    // ShotChangeArray:
    // (0) []
    // Source:
    // ''
    // start:
    // 4.458
    // SubtitleCaption:
    // '<i>and receives 90,000 won</i>\n<i>of seniority allowance monthly.</i>'
    // tSubType:
    // 1 

    let lastIndex = 0;
    if (index > 0) {
        lastIndex = index - 1;
      // 上一個物件
      const lastObj = DataObjArray[lastIndex];
      const distance = DataObj.getDistance(lastObj, ROWoBJ);
      if (distance < 0) { 
        const newStyleCheckObj = new StyleCheckObj({
          rowIndex: lastIndex,
          typeName: 'Timecode Error',
          errorMessage: `timecode distance error`,
        });
        this.TotalErrorData['Timecode Error'].push(newStyleCheckObj); 
      }

      
    }

    if (
      //   In.includes(NaN) ||
      //   Out.includes(NaN) ||
      isNaN(Duration) ||
      Duration < 0
    ) { //  NaN 錯誤
      const newStyleCheckObj = new StyleCheckObj({
        rowIndex: index,
        typeName: 'Timecode Error',
        errorMessage: `Not timecode format`,
      });
      this.TotalErrorData['Timecode Error'].push(newStyleCheckObj);
    }
 
  }
}

export default Style;



// WEBPACK FOOTER //
// ./src/class/Style.js